import uiEn from './i18n/en/ui.js';
import permissionsEn from './i18n/en/permissions.js';

import routes from './routes/routes.js'
import leftMenuConfig from './menus/left.js'; // Import the config object
import topMenuConfig from './menus/top.js';
import ChatDock from './components/dock/ChatDock.vue';

export default ({ app, addLeftMenuItem, addTopMenuItem, addTranslations, addPermissionTranslations, router }) => {
  app.component('UmisisChatDock', ChatDock);

  // ADD LANGUAGES
  addTranslations('en', uiEn,'chat');
  addPermissionTranslations('en', permissionsEn);

  // ADD ROUTES
  routes.forEach(route => {
    router.addRoute(route);
  });

  // ADD MENU LEFT ITEMS
  if (leftMenuConfig.items) {
    leftMenuConfig.items.forEach(item => {
      addLeftMenuItem(item);
    });
  }
  // ADD MENU TOP ITEMS
  if (topMenuConfig.items) {
    topMenuConfig.items.forEach(item => {
      addTopMenuItem(item);
    });
  }
}
